var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slider',{attrs:{"max":_vm.sliderData.max,"min":_vm.sliderData.min,"readonly":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }